'use strict'

angular
    .module('rmDashboard')
    .directive('defaultDashboard', require('./default_dashboard.js').default)
    .directive('timeTableDashboard', require('./time_table_dashboard.js').default)
    .directive('dashboardBroadcast', require('./dashboard_broadcast.js').default)
    .directive('dashboardBroadcastIntermezzo', require('./dashboard_intermezzo.js').default)
